export default {
    name: 'contact',
    data() {
        return {
            sent: false,
            sending: false
        }
    },
    computed: {
        system() {
            return this.$root.$data.system
        }
    },
    methods: {
        send(event) {
            this.sending = true
            let form = event.target
            let data = {
                "name": form.name.value, "email": form.email.value,
                "phone": form.phone.value, "message": form.message.value
            }
            this.axios.post('/api/contact', data)
                .then((response) => {
                    // console.log(response)
                    this.sent = true
                    this.sending = false
                }).catch((error) => {
                    console.log(error)
                    this.sent = false
                    this.sending = false
                })
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/contact/contact.js